import React from 'react'
import { Paragraph, DialogOverlay, Bleed } from '@fs/zion-ui'
import { css } from '@linaria/core'
import type { UseOverlayReturnOptions } from '@fs/zion-ui'

const wrapCss = css`
  white-space: pre-wrap;
`

type Props = {
  overlay: UseOverlayReturnOptions
  text: string
  title: string
}
export default function LifeHistoryDialog({ overlay, text, title }: Props): JSX.Element {
  return (
    <DialogOverlay {...overlay} title={title}>
      <Bleed top>
        <div className={wrapCss}>
          <Paragraph size="sm">{text}</Paragraph>
        </div>
      </Bleed>
    </DialogOverlay>
  )
}
